<template>
    <div>
        <Topo :btnLogout="true" :acessoRestritoMenu="true"></Topo>
        <div>
            <Migalha  v-if="$verificaPerfilCadastrador()" label="Atualizar Fornecedor"> </Migalha>
            <Migalha  v-else label="Consultar Fornecedor"></Migalha>
        </div>
        

      
       <v-card>
            <v-form ref="formPesquisarFornec" v-model="valid">
                <v-layout row wrap>
                    <v-flex xs12 sm6 md4>
                        <v-text-field
                        v-model="model.CpfCgcFornecedor"
                        :label="$t('label.cpfCnpj')"
                        v-mask="maskDocumentoIdentificacao"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md8>
                        <v-text-field
                            v-model="model.NomeFornecedor"
                            :label="$t('label.nomeRazao')"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                        <v-text-field
                            v-model="model.NumCrcCrs"
                            maxlength="8"
                            :label="$t('label.crcCrs')"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                        <v-select
                        v-model="model.SituacaoFornecedor"
                        :items="enumSituacaoCadastral"
                        item-text="descricao"
                        item-value="valor"
                        :label="$t('label.situacaoCadastral')"
                        clearable
                        ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                    <v-text-field
                        v-model="model.Email"
                        maxlength="50"
                        :label="$t('label.email')"
                        ></v-text-field>
                    </v-flex>              
                    <v-flex xs12 sm6 md4>
                        <datePicker                      
                        v-model="model.PeriodoSolicitacaoIni"
                        :dataDefault="model.PeriodoSolicitacaoIni "
                        v-mask="maskData"
                        :label="$t('label.dataInicio')"
                        :rules="[]"
                        :bloquearData="(bloquearDataSituacao===false && bloquearDataCrcCrs===false)?false:true"
                        :key="keyDataIni"
                        />
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                        <datePicker                        
                        v-model="model.PeriodoSolicitacaoFim"
                        :dataDefault="model.PeriodoSolicitacaoFim"
                        :label="$t('label.dataFinal')"
                        v-mask="maskData"
                        :rules="[]"
                        :key="keyDataFim"
                        :bloquearData="(bloquearDataSituacao===false && bloquearDataCrcCrs===false)?false:true"
                        />
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                        <v-text-field 
                          v-model="model.numeroSolicitacao"
                          :label="$t('label.numeroSolicitacao')">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs4 sm2 md2>
                        <v-btn large color="info" @click="pesquisarCadastros(true)">Pesquisar</v-btn>
                        
                    </v-flex>     
                  
                    <v-flex xs4 sm2 md1 v-show="true">
                        <a color="info" v-if="!$verificaPerfilCadastrador()" @click="exportarExcel()">
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                            width="48" height="48"
                            viewBox="0 0 192 192"
                            style=" fill:#000000;">
                                <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,192v-192h192v192z" fill="none"></path>
                                    <g fill="#2ecc71">
                                        <path d="M96,24l-80,16v112l80,16zM112,40v16h16v16h-16v16h16v16h-16v16h16v16h-16v16h56c4.416,0 8,-3.584 8,-8v-96c0,-4.416 -3.584,-8 -8,-8zM144,56h16v16h-16zM33.40625,66.375h14.21875l7.39062,17.71875c0.6,1.448 1.05163,3.12725 1.51562,5.03125h0.20313c0.264,-1.144 0.80138,-2.89187 1.60938,-5.17187l8.23437,-17.57813h12.96875l-15.48438,29.35938l15.9375,29.89062h-13.82812l-8.90625,-19.3125c-0.336,-0.68 -0.7345,-2.04912 -1.0625,-3.95312h-0.125c-0.2,0.912 -0.60312,2.27738 -1.20312,4.10938l-8.98438,19.15625h-13.89062l16.48438,-29.65625zM144,88h16v16h-16zM144,120h16v16h-16z">                                           
                                        </path>
                                    </g>
                                </g>
                            </svg>
                        </a>
                    </v-flex>
                </v-layout>
            </v-form>
            <v-flex>
                <v-data-table
                :headers="headers"
                :items="listaFornecCadastro"
                hide-actions
                class="tableLista"
                :pagination.sync="toggleOrder"
                :disable-initial-sort="true"
                >
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-center" nowrap style="max-width:150px">
                            <v-tooltip top >
                            <v-btn slot="activator" icon @click="visualizarItem(props.item)">
                                <v-icon color="primary">search</v-icon>
                            </v-btn>
                            <span>Visualizar</span>
                            </v-tooltip>
                        </td>
                        <td class="text-xs-left" nowrap>{{ props.item.numCgcFornecedor | formatCpfCnpj }}</td>
                        <td class="text-xs-left" nowrap>{{ props.item.nomFornecedor }}</td>
                        <td class="text-xs-left" nowrap>{{ props.item.numCrc }}</td>
                        <td class="text-xs-left" nowrap>{{ props.item.situacaoSimpasStr }}</td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-card>
        <v-layout row>
            <v-flex xs12 style="max-width: 1172px;">
                <div class="text-xs-center pt-2">
                    <v-pagination v-model="model.Page"
                    :length="totalPages"
                    :total-visible="pagination.rowsPerPage"
                    @input="carregarLista">
                    </v-pagination>
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
    import Migalha from "../../../components/migalha";
    import Topo from "../../../components/Topo";
    import Vue from 'vue';
    import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
    import dominioService from "../../../services/dominioService";

    import moment from "moment";
    import "moment/locale/pt-br";

    export default {
        mixins: [util],
        components: { /*Componentes utilizados*/
            Migalha,
            Topo
        },
        watch: { //Propriedades assistidas
            "model.NumCrcCrs": {
                handler(newValue) { /*Se houver um novo valor*/
                   if (newValue != null && newValue!=="") {
                        this.bloquearDataCrcCrs=true;
                        this.model.PeriodoSolicitacaoIni =null;
                        this.model.PeriodoSolicitacaoFim=null;
                        this.keyDataIni++;
                        this.keyDataFim++;
                    } else{
                        this.bloquearDataCrcCrs=false;
                    }
                }
            },

            "model.SituacaoFornecedor": {
                handler(newValue) { /*Se houver um novo valor*/
                   if (newValue != null && newValue > 0) { // newValue > 0 => usuario selecionou alguma situação cadastral
                        this.bloquearDataSituacao=true;
                        this.model.PeriodoSolicitacaoIni =null;
                        this.model.PeriodoSolicitacaoFim=null;
                        this.keyDataIni++;
                        this.keyDataFim++;
                    } else{
                        this.bloquearDataSituacao=false;
                    }
                }
            },

            "model.TotalItems": {
                handler(newValue) { /*Se houver um novo valor*/
                    if (newValue !== 0){
                        this.totalPages = Math.ceil(
                        this.model.TotalItems / this.model.rowsPerPage
                        );
                    } else {
                        this.totalPages = 0;
                    }
                }
            },
            toggleOrder: {
                handler(newValue, oldValue) {
                    if (Object.keys(oldValue).length > 2) {
                        this.pagination.sortBy = newValue.sortBy;
                        this.pagination.descending = newValue.descending ? true : false;
                        this.carregarLista();
                    }
                }
            },
        },
        methods:{
            // carrega a lista de fornecedores do banco de 10 em 10
            carregarLista(page) {
                this.model.Page = page;
                this.model.descending = this.pagination.descending;
                this.model.sortBy = this.pagination.sortBy;
                this.$mostrarPreload(); /*Exibir o PreLoad*/
                fornecedorService.getListaCadastro(this.model).then(response => { /*resposta do servico*/
                    this.ObjFornecCadastro = response.data; /*dados de retorno*/
                    this.listaFornecCadastro = response.data.fornecedorLista;
                    this.model.TotalItems = response.data.totalItems;

                    this.$removePreload(); /*Ocultar o PreLoad*/
                });
            },
            // pesquisa os fornecedores a partir dos filtros
            pesquisarCadastros(pesquisar) {
                if (pesquisar) {
                    this.model.Page = 1;
                }
                if(this.verificaFiltrosVazios()){ // pelo menos algum filtro não está vazio
                    if(this.verificaPeriodoValido()){
                        if(this.model.SituacaoFornecedor == null || this.model.SituacaoFornecedor === undefined){
                            this.model.SituacaoFornecedor = -1;
                        }
                        this.carregarLista();
                    } else {
                        //mensagem de erro, somente uma das datas foram preenchidas
                        // ou data inicial é maior do que data final
                        this.listaFornecCadastro = [];
                        Vue.toasted.error(this.$t("messages.erro.periodoInvalido"));
                    }
                } else {
                    //mensagem de erro, todos os filtros estao vazios
                    this.listaFornecCadastro = [];
                    Vue.toasted.error(this.$t("messages.erro.filtrosVazios"));
                }
            },
            // verifica se todos os filtros estão vazios
            verificaFiltrosVazios() {
               if(this.verificaCpfCnpjVazio() && this.verificaNomeRazaoVazio() && this.verificaCrcCrsVazio()){
                   if(this.verificaSituacaoFornecedorVazio() && this.verificaEmailVazio() && this.verificaNumeroSolicitacaoVazio())
                        if(this.verificaPeriodoInicialVazio() && this.verificaPeriodoFinalVazio())
                            return false; // todos os filtros estao vazios
               }
                return true; // existe filtro que não está vazio
            },

            verificaCpfCnpjVazio(){
                if(this.model.CpfCgcFornecedor == null
                || this.model.CpfCgcFornecedor === undefined
                || this.model.CpfCgcFornecedor.trim()=== "")
                    return true; // cpf/cnpj não foi preenchido
                else
                    return false // cpf/cnpj foi preenchido
            },

            verificaNomeRazaoVazio(){
                if(this.model.NomeFornecedor == null
                || this.model.NomeFornecedor === undefined
                || this.model.NomeFornecedor.trim()=== "")
                    return true; // Nome/Razao Social não foi preenchido
                else
                    return false // Nome/Razao Social foi preenchido
            },

            verificaCrcCrsVazio(){
                if(this.model.NumCrcCrs == null ||
                this.model.NumCrcCrs === undefined ||
                this.model.NumCrcCrs.trim() === "")
                    return true; // CRC/CRS não foi preenchido
                else
                    return false // CRC/CRS foi preenchido
            },

            verificaSituacaoFornecedorVazio(){
                if (this.model.SituacaoFornecedor == null
                || this.model.SituacaoFornecedor === undefined
                || this.model.SituacaoFornecedor === -1)
                    return true; // Situação Fornecedor não foi preenchida
                else
                    return false // Situação Fornecedor foi preenchida
            },

            verificaEmailVazio(){
                if(this.model.Email == null
                || this.model.Email === undefined
                || this.model.Email.trim() === "")
                    return true; // E-mail não foi preenchido
                else
                    return false // E-mail foi preenchido
            },

            verificaPeriodoInicialVazio(){
                if(this.model.PeriodoSolicitacaoIni == null
                || this.model.PeriodoSolicitacaoIni === undefined
                || this.model.PeriodoSolicitacaoIni.trim() === "")
                    return true; // Data Inicial não foi preenchida
                else
                    return false // Data Inicial foi preenchida
            },

            verificaPeriodoFinalVazio(){
                if(this.model.PeriodoSolicitacaoFim == null
                || this.model.PeriodoSolicitacaoFim === undefined
                || this.model.PeriodoSolicitacaoFim.trim() === "")
                    return true; // Data Final não foi preenchida
                else
                    return false; // Data Final foi preenchida
            },

            // verifica se o periodo foi preenchido corretamente
            verificaPeriodoValido(){
                var flagDataIni;
                var flagDataFinal;

                if(this.model.PeriodoSolicitacaoIni != null && this.model.PeriodoSolicitacaoIni !== undefined && this.model.PeriodoSolicitacaoIni .trim()!==""){
                    flagDataIni = true;
                } else{
                    flagDataIni = false;
                }

                if(this.model.PeriodoSolicitacaoFim != null && this.model.PeriodoSolicitacaoFim !== undefined && this.model.PeriodoSolicitacaoFim.trim()!==""){
                    flagDataFinal = true;
                }else {
                    flagDataFinal = false;
                }

                // verifica se o usuario só preencheu uma data ou se data inicial é maior que a final
                if((flagDataIni===true && flagDataFinal===false)
                || (flagDataFinal===true && flagDataIni===false)
                || (this.model.PeriodoSolicitacaoIni  > this.model.PeriodoSolicitacaoFim))
                    return false;
                else
                    return true;
            },

            verificaNumeroSolicitacaoVazio(){
                if(this.model.numeroSolicitacao == null ||
                   this.model.numeroSolicitacao.trim() === "")
                    return true; // Data Final não foi preenchida
                else
                    return false; // Data Final foi preenchida
            },

            visualizarItem(item) {
                this.$mostrarPreload(); /*Exibir o PreLoad*/
                this.$router.push({
                    path: `/arearestrita/habilitador/fornecedor-detalhe/${item.numCgcFornecedor}`,
                });
                this.$removePreload(); /*Ocultar o PreLoad*/
            },

            exportarExcel(){
                if (this.listaFornecCadastro.length > 0){
                    this.model.TodosResultados = true;

                    // 2 gera excel de cadastros de fornecedores
                    fornecedorService.exportarExcel(this.model, 2);
                    this.model.TodosResultados = false;
                }
            },
            changeSort (column) {
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column
                    this.pagination.descending = false
                }
            }
        },

        created() /*Metodo de start do componente*/{
            dominioService.geEnums().then(response => { /*resposta do servico*/
                this.enums = response.data; /*dados de retorno*/
                this.enumSituacaoCadastral = this.enums.situacaoFornecedor.filter(x=>x.chave !== "Nenhum");
            });

            this.model.PeriodoSolicitacaoIni=null;
            this.model.PeriodoSolicitacaoFim=null;
        },
        computed: {//Campos computados
        },

        data() {//Declaracao de variaveis
            return {
                model: {
                    PeriodoSolicitacaoIni : null,
                    PeriodoSolicitacaoFim: null,
                    CpfCgcFornecedor: null,
                    NomeFornecedor: null,
                    NumCrcCrs: null,
                    SituacaoFornecedor: null,
                    Email: null,
                    Page: null,
                    rowsPerPage: 10,
                    TodosResultados: false,
                    TotalItems: null,
                    numeroSolicitacao: null,
                },
                valid: true,
                enumSituacaoCadastral: [],
                bloquearDataCrcCrs: false,
                bloquearDataSituacao: false,
                keyDataIni:1,
                keyDataFim:1,
                listaFornecCadastro: [],
                ObjFornecCadastro: Object,
                headers: [ /*Cabeçalho da data-table*/
                    { text: "Ações", value: "", width: 10, class: "text-xs-center", sortable: false },
                    { text: "CNPJ/CPF", width: 100, sortable: true, value: "numCgcFornecedor"},
                    { text: "Nome/Razão Social", width: 400, sortable: true, value: "nomFornecedor" },
                    { text: "Nº CRC/CRS", width: 100, sortable: true, value: 'numCrc' },
                    { text: "Situação CAF Digital", width: 100, sortable: true, value: "situacaoSimpasStr" },
                ],
                pagination: {
                    sortBy: 'nomFornecedor',
                    descending: false,
                    rowsPerPage: 10
                },
                toggleOrder: {
                    rowsPerPage: 10,
                    descending: false
                },
                totalPages: 0,
            };
        },
    };
</script>